import {default as clientConfig} from './client.json';
import {default as appVersion} from './app-version.json';

type RuntimeConfig = {
    [P in keyof typeof clientConfig]: (typeof clientConfig)[P]
}

export function getRunTimeConfig(): RuntimeConfig {
    const base: RuntimeConfig = {...clientConfig};

    const mutator: Pick<
        RuntimeConfig,
        'app-env'
        | 'app-url'
        | 'app-name'
        | 'app-version'
        | 'app-knowledge-base-host'
        | 'app-has-remote-knowledge-base'
        | 'sentry'
        | 'broadcasting'
    > = {
        'app-env': APP_ENV,
        'app-url': APP_URL,
        'app-name': APP_NAME,
        'app-knowledge-base-host': APP_KNOWLEDGE_BASE_HOST,
        'app-has-remote-knowledge-base': (// APP_KNOWLEDGE_BASE_HOST != localhost
            APP_KNOWLEDGE_BASE_HOST != null &&
            String(APP_KNOWLEDGE_BASE_HOST).length > 0 &&
            !(/^(https?:\/\/|.{0})localhost/ui).test(String(APP_KNOWLEDGE_BASE_HOST))
        ),
        'app-version': appVersion,
        'sentry': {
            ...base['sentry'],
            'active': Boolean(SENTRY_REACT_DSN),
        },
        'broadcasting': {
            ...base['sentry'],
            'app-key': MIX_PUSHER_APP_KEY,
            'host': MIX_PUSHER_HOST,
            'scheme': MIX_PUSHER_SCHEME,
            'ws-port': MIX_PUSHER_PORT,
            'wss-port': MIX_PUSHER_PORT,
            'cluster': MIX_PUSHER_APP_CLUSTER,
        }
    };

    return {...base, ...mutator};
}
